module.exports = __webpack_public_path__ + "img/rock.ee6de2ce.png";